import React, { useState, useEffect } from "react";
import AuthenticatedComponent from "./AuthenticatedComponent";
import ApartmentService from "../services/ApartmentService.js";
import EmailService from "../services/EmailService.js";
import ReactQuill from "react-quill";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import queryString from "query-string";
import RateService from "../services/RateService";

const RecipientType = {
  WaitinglistRecipients: "waitinglistrecipients",
  CoopShareHolders: "coopshareholders"
}

function LetterEditor(props) {
  const navigate = useNavigate();
  
  const getInitialState = () => {
    var checked = [];
    var recipientType = RecipientType.WaitinglistRecipients;
    if (props.query.get("apartments")) {
      var apartments = props.query.get("apartments");
      checked = apartments.split(",");
    }

    return {
      checked: checked,
      letter: null,
      waitingListLetters: {
        B: true,
        D: true,
        E: true,
      },
      recipientType: recipientType
    };
  };

  const [checked, setChecked] = useState(() => {
    if (props.query.get("apartments")) {
      var apartments = props.query.get("apartments");
      return apartments.split(",");
    }
    return [];
  });
  
  const [letter, setLetter] = useState(null);
  const [waitingListLetters, setWaitingListLetters] = useState({
    B: true,
    D: true,
    E: true,
  });
  const [recipientType, setRecipientType] = useState(RecipientType.WaitinglistRecipients);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (props._apartments.length === 0) {
      ApartmentService.getApartments();
    }
    if (!props._rate) {
      RateService.ratesGet();
    }
  }, [props._apartments.length, props._rate]);

  const getApartmentsState = () => {
    return props._apartments;
  };

  const backClick = () => {
    navigate("/lejligheder");
  };

  const sendClick = (e) => {
    e.preventDefault();

    if(recipientType === RecipientType.CoopShareHolders) {
      EmailService.sendCoopOwnerEmail({
        subject: "Besked fra A/B Vanløsegaard",
        content: letter
      });
    } else {
      var waitingListLettersArray = [];

      if (waitingListLetters.B) {
        waitingListLettersArray.push("B");
      }

      if (waitingListLetters.D) {
        waitingListLettersArray.push("D");
      }

      if (waitingListLetters.E) {
        waitingListLettersArray.push("E");
      }

      EmailService.sendWaitingListEmail({
        subject: "Lejlighed(er) til salg",
        content: letter,
        waitinglistletters: waitingListLettersArray,
      });
    }
    navigate("/lejligheder");
  };


  const footer = () => {
    return '<div><span>Med venlig hilsen</span></div>'+
  '<div>Bestyrelsen</div>'+
  '<div>A/B Vanl&oslash;segaard</div><div><br />'+
  '</div><div>-------------------------------------</div>'+
  '<div><span>Jernbane All&eacute; 92, st.th. 2720 Vanl&oslash;se</span></div>'+
  '<div>www.vanlosegaard.dk</div><div>Telefon 38 74 48 52</div><div>Cvr nr. 43076019</div><div>Matr. nr. 2495</div><div>BBR nr. 285529</div>';
  };

  const coopOwnerLetter = () => {
    return footer();
  };

  const waitingListLetter = (apartments, checkedApartments, currentRecipientType) => {
    var addressesDiv = "";
    apartments.forEach(function (apartment) {
      if (checkedApartments.includes(apartment.id.toString()))
        addressesDiv +=
          "<div>" +
          apartment.address +
          "   Kl. XX.XX - XX.XX   <br>Maksimalpris: kr. " +
          apartment.price +
          "<br>" +
          apartment.type +
          " " +
          apartment.sqm +
          "Kvm.<br>Andelsværdi:" +
          apartment.andelskroner *
          parseFloat(props._rate.replace(",", ".")) +
          " kr.<br>Forbedringer:" +
          apartment.improvements +
          " kr.<br>Alm løsøre:" +
          apartment.alm_losore +
          " kr.<br>Tilpassede løsøre: " +
          apartment.adjusted_losore +
          " kr.<br>Fradrag: " +
          apartment.special_conditions +
          " kr.<br>Månedlig boligafgift: " +
          apartment.apartmentFee +
          " kr.<br><br></div>";
    });

    return (
      '<div style="font-family: sans-serif;"><div><span style="font-size: 18px;"><b>Andelsboligforeningen Vanl&oslash;segaard</b></span></div><div><br /></div><div><span><b>Vedr.: Salg aflejligheder</b></span></div><div><br /></div><div>XX. XXXXXX 20XX fremvises f&oslash;lgende lejlighed er til salg i A/B Vanl&oslash;segaard</div><div><br /></div><div><br /></div>' +
      addressesDiv +
      '<div><br /></div><div><br /></div><div><span><i>NB! Prisen er maksimalprisen inklusive fradrag for s&aelig;rlige forhold.</i></span></div><div><br /></div><div>I kan til fremvisningen f&aring; oplyst, hvor I st&aring;r p&aring; ventelisten til netop denne lejlighed.</div><div><br /></div><div>Den oplyste andelsv&aelig;rdi tager ikke hensyn til forbedringer og fradrag, og der vil s&aring;ledes v&aelig;re forskel til den reelle andelsv&aelig;rdi. Andelsv&aelig;rdien er oplyst idet vurderingsrapporterne ikke er modtaget endnu. <b>Den g&aelig;ldende maksimale overdragelsessum kan oplyses ved fremvisningen.</b></div><div><br /></div>'+
      footer() +'</div>'
    );
  };

  const onTextChange = (value) => {
    setLetter(value);
  };

  const waitingListSelector = () => {
    return (<div className="col-4">
      <div className="form-check form-check-inline">
        <input
          className="form-check-input mb-0"
          type="checkbox"
          id="inlineCheckbox1"
          checked={waitingListLetters.B}
          onChange={() =>
            setWaitingListLetters({
              ...waitingListLetters,
              B: !waitingListLetters.B,
            })
          }
        />
        <label className="form-check-label" htmlFor="inlineCheckbox1">
          B
        </label>
      </div>
      <div className="form-check form-check-inline">
        <input
          className="form-check-input mb-0"
          type="checkbox"
          id="inlineCheckbox2"
          checked={waitingListLetters.D}
          onChange={() =>
            setWaitingListLetters({
              ...waitingListLetters,
              D: !waitingListLetters.D,
            })
          }
        />
        <label className="form-check-label" htmlFor="inlineCheckbox2">
          D
        </label>
      </div>
      <div className="form-check form-check-inline">
        <input
          className="form-check-input mb-0"
          type="checkbox"
          id="inlineCheckbox3"
          checked={waitingListLetters.E}
          onChange={() =>
            setWaitingListLetters({
              ...waitingListLetters,
              E: !waitingListLetters.E,
            })
          }
        />
        <label className="form-check-label" htmlFor="inlineCheckbox3">
          E
        </label>
      </div>
    </div>)
  };

  // Effect to set the initial letter when conditions are met
  useEffect(() => {
    if (recipientType === RecipientType.WaitinglistRecipients &&
      letter === null &&
      props._rate &&
      props._apartments.length > 0) {
      setLetter(waitingListLetter(props._apartments, checked, recipientType));
    }
  }, [recipientType, letter, props._rate, props._apartments.length, props._apartments, checked]);

  return (
    <div className="container standardBackground">
      <div className="row my-3">
        <form className="form-inline mt-1 col-12">

          <div className="col-4">
            <h4>Hvem skal modtage beskeden?</h4>
          </div>

          <div className="col-4 ">
            <div className="form-check ">
              <input
                className="form-check-input mb-0"
                type="radio"
                id="inlineRadiobox1"
                checked={recipientType === RecipientType.WaitinglistRecipients}
                onChange={() => setRecipientType(RecipientType.WaitinglistRecipients)}
              />
              <label className="form-check-label" htmlFor="inlineRadiobox1">
                Folk på venteliste
              </label>
            </div>
            <div className="form-check ">
              <input
                className="form-check-input mb-0"
                type="radio"
                id="inlineRadiobox2"
                checked={recipientType === RecipientType.CoopShareHolders}
                onChange={() => {
                  setRecipientType(RecipientType.CoopShareHolders);
                  setLetter(coopOwnerLetter());
                }}
              />
              <label className="form-check-label" htmlFor="inlineRadiobox2">
                Alle andelshavere
              </label>
            </div>
          </div>
          {recipientType === RecipientType.WaitinglistRecipients &&
            waitingListSelector()}
        </form>

      </div>
      <div className="row">
        {loading && <div>Loading...</div>}
        {!loading && (
          <div id="emailEdit" className="col-md">
            <ReactQuill
              theme="snow"
              value={letter}
              onChange={onTextChange}
            />
            <button
              className="btn btn-primary"
              onClick={backClick}
            >
              Afbryd
            </button>
            <button
              className="btn btn-primary"
              onClick={sendClick}
            >
              Send
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  const { _apartments } = state.apartments;
  const { _rate } = state.rate;
  return { _apartments, _rate };
}

export default AuthenticatedComponent(
  connect(mapStateToProps)(LetterEditor)
);
